/* eslint-disable prefer-const */
import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewChild,
} from "@angular/core";
import { CustomMapComponent } from "app/components/shared/custom-map/custom-map.component";
import { ConfirmationService, SelectItem } from "primeng/api";
import { Auxiliar } from "../../../model/Auxiliar";
import { NoticegroupService } from "../../../rest/noticegroup.service";
import { Rest } from "../../../rest/rest_client";
import { ZoneService } from "../../../rest/zone.service";
import { UserService } from "app/rest/user.service";
import { RoutesService } from "app/modules/task/administration/services/routes.service";
import { ZonegroupService } from "../../../rest/zonegroup.service";
import { AuthenticationService } from "../../../core/services/authentication/authentication.service";
import { CercaliaMapService } from "../../../services/cercalia-map/cercalia-map.service";
import { I18nService } from "../../../services/i18n/i18n.service";
import {
    NotificationsService,
    Severity,
} from "../../../services/notifications-service/notifications.service";
import { RestExt } from "../../../services/rest-client-extension";
import { EntityFormComponent } from "../../entity-form/entity-form.component";
import {
    CreateZoneMarkerEvent,
    CustomMapOptions,
    DrawZoneType,
    UpdateZoneMarkerEvent,
} from "../../shared/custom-map/custom-map.model";
import { ZoneGroupFormComponent } from "../zone-group-form/zone-group-form.component";
import Zone = Rest.Zone;
import { TranslateService } from "@ngx-translate/core";
import { Rest_logistics } from "app/modules/task/Logistics/services/rest_client_logistics";
import { Rest_task } from "app/modules/task/administration/services/rest_client_task";
import { takeWhile } from 'rxjs/operators';

@Component({
    selector: "app-zone-form",
    templateUrl: "./zone-form.component.html",
    styleUrls: ["./zone-form.component.scss"],
    providers: [
        ZonegroupService,
        ZoneService,
        CercaliaMapService,
        ConfirmationService,
        NoticegroupService,
        UserService,
        RoutesService
    ],
    standalone: false
})
export class ZoneFormComponent
    extends EntityFormComponent<Rest.Zone>
    implements OnInit {
    title: string;
    Types: SelectItem[];
    disableZoneTypeSelector = false;
    numevents: SelectItem[];
    user: Rest.User;

    // Change:
    //@Input() zonesList: Rest.Zone[];

    // -------------- //
    // OPCIONES MAPA  //
    // showMap = true;
    showMap = false;
    customMapOptions: CustomMapOptions = {};
    currentZonesToDisplay: Rest.Zone[] = [];

    //Input data for the component. They're used for map configuration.
    zones: Rest.Zone[] = [];

    @ViewChild(ZoneGroupFormComponent, { static: true })
    zoneGroupForm: ZoneGroupFormComponent;
    @ViewChild(CustomMapComponent) map: CustomMapComponent;

    //Evento que genera el formulario cuando se quiere actualizar la posición de un poi
    @Output() updateZoneEvent: EventEmitter<UpdateZoneMarkerEvent> =
        new EventEmitter<UpdateZoneMarkerEvent>();
    //Emitted whenever the form dialog is closed, saved or not
    @Output() closed: EventEmitter<void> = new EventEmitter<void>();
    @Input() realTime: boolean;

    zoneGroupCreated: Rest.ZoneGroup;
    noticeGroupCreated: Rest.NoticeGroup;
    selectedZoneGroup: Rest.ZoneGroup;
    availableZoneGroups: SelectItem[];
    zoneGroups: Rest.ZoneGroup[];
    plannerzone:boolean=false;
    selectedzoneGroups: Rest.ZoneGroup[];
    selectedPreconfig2: any;

    // End OPCIONES MAPA  //
    // ------------------ //
    zoneGroupService: ZonegroupService;

    // ------------------ //
    // FORM LABELS //
    zoneData: string;
    zoneName: string;
    zoneType: string;
    zonedrivers:string;
    zoneroutes:string;
    enabledLabel: string;
    eventsLabel: string;
    enterLabel: string;
    leaveLabel: string;
    zoneGroupLabel: string;
    zonePlaceholder: string;
    saveButton: string;
    customPoints: string;
    NoRoutes:string;
    zonerouteselected:string;
    driverselected:string;
    nodriver:string;
    // End FORM LABELS  //
    // ------------------ //
    selectedRoutes: Rest_task.Route[];
    selectedUsers:Rest.User[];
    availableRoutes: Rest_task.Route[];
    availableUsers:Rest.User[];
    userplan: Rest_task.UserPlanner[];

    constructor(
        zoneService: ZoneService,
        notificationsService: NotificationsService,
        private translate: TranslateService,
        protected i18n: I18nService,
        private confirmationService: ConfirmationService,
        private noticegroupService: NoticegroupService,
        private cercaliaMapService: CercaliaMapService,
        zonegroupService: ZonegroupService,
        protected authenticationService: AuthenticationService,
        protected routesservice:RoutesService,
        protected userservice:UserService
    ) {
        // @ts-ignore
        super(zoneService, notificationsService, i18n, authenticationService);
        this.zoneGroupService = zonegroupService;
    }

    ngOnInit() {
        this.zones=[];
        let that = this;
        super.ngOnInit();
        this.selectedPreconfig2=null;
        /**Permissions */
        this.plannerzone = false;
        this.user = this.authenticationService.user;
        /** */
        this.numevents = [];
        this.numevents.push({ label: "1", value: 1 });
        this.numevents.push({ label: "2", value: 2 });
        this.numevents.push({ label: "3", value: 3 });
        this.numevents.push({ label: "4", value: 4 });
        this.numevents.push({ label: "5", value: 5 });
        this.Types = [];
        this.Types.push({ label: this.translate.instant('i18nMigrated.circular'), value: true });
        this.Types.push({ label: this.translate.instant('i18nMigrated.poligonal'), value: false });

        this.translateLabels();

        this.zoneGroupForm.return
            .pipe(takeWhile(() => this.alive))
            .subscribe((entity: Rest.ZoneGroup) => {
                if (entity !== undefined && entity.id > 0) {
                    that.confirmationService.confirm({
                        message: that.translate.instant('i18nMigrated.doYouWantToBeNotifiedAboutTheEventsOfTheZonesInThe'),
                        accept: () => {
                            let usersList = [];
                            let tagEventsList = [];
                            usersList.push(entity.owner);
                            tagEventsList.push("Zone_Enter_zgId" + entity.id);
                            tagEventsList.push("Zone_Leave_zgId" + entity.id);
                            that.plannerzone = entity.routeScheduler;
                            let newNoticeGroup: Rest.NoticeGroup = {
                                id: null,
                                enabled: true,
                                owner: entity.owner,
                                name: "Notice Group " + entity.name,
                                description: "Notice_Group_zgId" + entity.id,
                                notifyBySMS: true,
                                notifyByApp: true,
                                notifyByEmail: true,
                                notifyByWeb: true,
                                visibleUsers: usersList,
                                visibleFleets: entity.fleets,
                                visibleVehiclesGroups: entity.vehiclesGroups,
                                visibleVehicles: entity.vehicles,
                                tag_events: tagEventsList,
                                noticeChannelsStr: "",
                                visibleCustomers:[],
                                notificationText: "",
                                sender:"",
                                startDate: null,
                                endDate: null,
                                type: null,
                                mailBody:"",
                                mailSubject:"",
                                smsMessage:""
                            };

                            that.noticegroupService
                                .create(newNoticeGroup)
                                .then(
                                    function (ret) {
                                        that.notificationsService.add(
                                            Severity.success,
                                            that.translate.instant('i18nMigrated.x'),
                                            that.translate.instant('i18nMigrated.noticeGroupCreated')
                                        );
                                        that.noticeGroupCreated = ret;
                                    },
                                    (err) => {
                                        console.log(err);
                                        that.handleError(err, that);
                                    }
                                )
                                .catch((e) => {
                                    this.handleError(e, that);
                                });
                        },
                    });



                    that.zoneGroups.push(Auxiliar.toEntitySelectItem(entity).value); //-- RAQUEL MIRAR PORQUE TENGO QUE COGER EL VALUE Y LUEGO NO REFRESCA EL LISTADO PRINCIPAL--//
                    that.availableZoneGroups.push(Auxiliar.toEntitySelectItem(entity));
                    that.selectedZoneGroup = entity;
                    that.entity.zoneGroup = entity;
                    that.selectedPreconfig2={
                        value: that.entity?.zoneGroup?.id ?? 0,
                        label: that.entity?.zoneGroup?.name ?? ''
                    };
                    that.notificationsService.add(
                        Severity.success,
                        that.translate.instant('i18nMigrated.x'),
                        that.translate.instant('i18nMigrated.zoneGroupCreated')
                    );
                    that.zoneGroupCreated = entity;
                }
            });
    }

    /**
     * Translate all the variables that are binded on the form,
     * using the translator library.
     *
     * @private
     * @memberof ZoneFormComponent
     */
    private translateLabels() {
        this.zoneData = this.translate.instant('zones.zone-form.zone-data');
        this.zoneName = this.translate.instant('zones.zone-form.name');
        this.zoneType = this.translate.instant('zones.zone-form.type');
        this.enabledLabel = this.translate.instant('zones.zone-form.enabled');
        this.eventsLabel = this.translate.instant('zones.zone-form.events');
        this.enterLabel = this.translate.instant('zones.zone-form.enter');
        this.leaveLabel = this.translate.instant('zones.zone-form.leave');
        this.zoneGroupLabel = this.translate.instant('zones.zone-form.zone-group');
        this.zonePlaceholder = this.translate.instant('zones.zone-form.select-zone');
        this.saveButton = this.translate.instant('zones.zone-form.save');
        this.customPoints = this.translate.instant('zones.zone-form.polylines');
        this.zonedrivers = this.translate.instant('administration.routes.drivers');
        this.zoneroutes = this.translate.instant('administration.routes.routes');
        this.NoRoutes = this.translate.instant('tableManagement.delegations.NoRoute');
        this.zonerouteselected = this.translate.instant('tableManagement.delegations.RoutesSelect');
        this.driverselected =this.translate.instant('tableManagement.delegations.DriversSelect');
        this.nodriver =this.translate.instant('tableManagement.delegations.NoDrivers');
    }

    zoneStringChanged(points) {
        this.entity.circular = false;
        if (points != null && points !== "") {
            this.entity.rawPolygonVertexList = '"POLYGON((' + points + '))"';
        }
        this.fireZoneTypeChangedEvent(null);
    }

    createZoneGroup() {
        this.zoneGroupForm.create();
    }

    close(event) {
        this.showMap = false;
        this.closed.emit();
    }

    private fireZoneTypeChangedEvent(event: any) {
        //console.log(event.value);
        this.configureMap();
    }

    notifyCreateZone(evtZone: CreateZoneMarkerEvent) {
        if (evtZone.zone.zoneType === DrawZoneType.Circle) {
            this.entity.radius = evtZone.zone.radius;
            this.entity.center = {
                latitude: evtZone.zone.centerLat,
                longitude: evtZone.zone.centerLon,
            } as Rest.Vertex;
        } else {
            this.entity.rawPolygonVertexList = evtZone.zone.wkt;
        }
    }

    notifyUpdateZone(event: UpdateZoneMarkerEvent) {
        this.updateZoneEvent.emit(event);
    }

    /**
     * Also show the server's validation errors: those about fields this form doesn't display
     * (coordinates, enabled...) used to be lost and the form seemed to do nothing
     */
    handleError(err, that) {
        try {
            super.handleError(err, that);
        } catch (e) {
            //Not a validation error with field details: shown below anyway
        }
        let details = '';
        try {
            const parsed = typeof err === 'string' ? JSON.parse(err) : err;
            details = (parsed?.errors || [])
                .map((x) => (x.fieldName ? x.fieldName + ': ' : '') + x.errorDescription)
                .join(' / ');
        } catch (e) {
            //A plain HTTP error text: the HTTP client has already shown its own message
            details = '';
        }
        //Without details the HTTP client has already shown its own generic error
        if (details) {
            this.notificationsService.add(Severity.error, this.translate.instant('general.error'), details);
        }
    }

    beforeSave() {
        //Send only the zone group's own simple fields: its lists (zones, which point back to the group...) make
        //the request preparation loop forever ("Maximum call stack size exceeded"). The server uses id, routeScheduler...
        if (this.entity.zoneGroup?.id != null) {
            const zoneGroup: any = {};
            Object.keys(this.entity.zoneGroup).forEach((key) => {
                const value = this.entity.zoneGroup[key];
                if (value === null || typeof value !== 'object') zoneGroup[key] = value;
            });
            this.entity.zoneGroup = zoneGroup as Rest.ZoneGroup;
        }
        if (this.entity.circular) {
            this.entity.rawPolygonVertexList = null;
            this.entity.zoneJSON = JSON.stringify({ vertex: [] });
        } else {
            let raw = this.entity.rawPolygonVertexList || "";
            //"POLYGON((0.1167197314239296 42.3141920646041,-2.2343544873260712 40.9013793289792,-1.7509560498260694 40.082599898966436,1.6108603564239306 41.61165338481504,0.1167197314239296 42.3141920646041))"
            //lon lat. Read every "lon lat" pair, whatever the spacing or quoting of the WKT text
            const pairs: string[] = raw.match(/-?\d+(?:\.\d+)?(?:e[-+]?\d+)?\s+-?\d+(?:\.\d+)?(?:e[-+]?\d+)?/gi) || [];
            let vertexList = [];
            pairs.forEach((pair) => {
                const lonLat = pair.trim().split(/\s+/);
                let lon = parseFloat(lonLat[0]);
                let lat = parseFloat(lonLat[1]);
                //Web Mercator meters instead of degrees: convert them
                if (Math.abs(lon) > 180 || Math.abs(lat) > 90) {
                    const earthRadius = 6378137;
                    lon = (lon / earthRadius) * (180 / Math.PI);
                    lat = (2 * Math.atan(Math.exp(lat / earthRadius)) - Math.PI / 2) * (180 / Math.PI);
                }
                vertexList.push({
                    lat: lat,
                    lon: lon,
                });
            });
            this.entity.zoneJSON = JSON.stringify({ vertex: vertexList });

            this.entity.radius = null;
            this.entity.center = null;
        }
    }

    zoneGroupChanged() {
        //esto lo he puesto porque al crear un grupo de zona, en this.selectedPreconfig2.value había el objeto completo de grupozona.
        if (this.selectedPreconfig2.value?.id)this.selectedPreconfig2.value = this.selectedPreconfig2.value.id;  
        this.entity.zoneGroup =     this.zoneGroups.find((zg) => zg.id === this.selectedPreconfig2.value);
        this.plannerzone = this.entity.zoneGroup.routeScheduler;
        if (this.plannerzone)
        {
            this.entity.circular = false; //all are poligonal
        }
        this.zones =  this.entity.zoneGroup?.zones //? [...this.entity.zoneGroup.zones] : [];

        //this.zones = this.zonesList;
        //remove zone from list
        if (!this.isNew) {
            this.zones.splice(
                this.zones.findIndex((z: Rest.Zone) => z.id === this.entity.id),
                1
            );
        }
        this.zones.push(this.entity);
        this.zones = this.zones.filter((z) => z.enabled);
    }

    configureMap() {
       
            //Se puede crear un solo poi al clicar en el mapa. El resto de pois no son editables (solo visibles)
            this.customMapOptions = {
                editZones: false,
                drawZones: true,
                editZoneid:this.entity.id,
                drawZoneType: this.entity.circular
                    ? DrawZoneType.Circle
                    : DrawZoneType.Polygon,
               
            };
            this.disableZoneTypeSelector = false;
        
    }

    async beforeShow() {

            this.selectedPreconfig2={
                value: this.entity?.zoneGroup?.id ?? 0,
                label: this.entity?.zoneGroup?.name ?? ''
            };
          //this.selectedPreconfig={label:this.entity.zoneGroup.name, value:this.entity.zoneGroup};
        this.plannerzone = false; 
        if (this.realTime) {
            this.showMap = false;
        } else {
            this.showMap = true;
        }

        this.selectedZoneGroup = null;
        let that = this;
        let currentZGId = this.entity.zoneGroup ? this.entity.zoneGroup.id : -1;

        let allZG = (
            await that.zoneGroupService.getPage(RestExt.allRecordsRequest())
        ).entities;
        this.zoneGroups = allZG.filter((zg) => zg.enabled || zg.id === currentZGId);
        this.selectedzoneGroups = allZG.filter((zg) => zg.id === currentZGId);
        this.availableZoneGroups = this.zoneGroups.map(item => ({
            value: item.id,
            label: item.name
          }));
       // this.availableZoneGroups = Auxiliar.toEntitySelectItemArr(this.zoneGroups);
      //  if ((this.selectedzoneGroups) && (this.selectedzoneGroups.length>0))  this.selectedPreconfig =this.selectedzoneGroups[0].id;
        //if ((this.selectedzoneGroups) && (this.selectedzoneGroups.length>0)) this.selectedPreconfig = {label:this.selectedzoneGroups[0].name, value:this.selectedzoneGroups[0]};
        // this.availableZoneGroups = this.zoneGroups.map(group => ({
        //     label: group.name,
        //     value: group.id
        //   }));

        this.selectedRoutes = [];
        this.selectedUsers = [];
        this.userplan=[];
        if (this.entity.routes != null) this.selectedRoutes = this.entity.routes;
        if (this.entity.userPlanners != null) 
        {   
            this.selectedUsers =this.entity.userPlanners.map(up => up.user);
            this.userplan = this.entity.userPlanners;
       }

      //Raquel       if (this.entity.users != null) this.selectedUsers =this.entity.users;

        if (this.entity.zoneGroup != null) {
            this.plannerzone = this.entity.zoneGroup.routeScheduler;
            if (this.plannerzone) this.entity.circular = false;

            
            // this.entity.zoneGroup = this.availableZoneGroups.find(
            //     group => group.id === this.entity.zoneGroup?.id
            //   );
            //  this.entity.zoneGroup = this.zoneGroups.find(
            //   (b) => b.id === this.entity.zoneGroup.id
            //  );
        }

        if(this.plannerzone){
            this.geRoutes();
        }
            
        this.getUsers(this.user.id);
    }

    geRoutes() {
        //get routes
        const that = this;
        let routesRequest = {
            sortBy: null,
            sortAsc: true,
            pageSize: 1000000,
            filters: {
            "deleted": ["false"]
            },
    
            loadPermissions: false
        } as unknown as Rest.ListPaginationRequest;
        const promise = new Promise<void>((resolve, reject) => {
            const that = this;
            this.routesservice.getPage(routesRequest)
            .then(
                function (response) {
                that.availableRoutes = response.entities;
    
                that.availableRoutes.sort((a, b) => a.name.localeCompare(b.name));
                },
                function (error) {
                console.log('The request failed: ' + error);
                resolve();
                },
            )
            .catch(function (reason) {
                console.log('Catched: ' + reason);
                resolve();
            });
        });

     }

     getUsers(userId) {
        const promise = new Promise<void>((resolve, reject) => {
          let paginationRequest = RestExt.firstPageRequest();
          const that = this;
    
          this.userservice
            .userAllDataTask(userId)
            .then(
              function (response) {
                //Usuaris
                that.availableUsers = response.children.filter(user => (user.usertype.some(type =>type.projectstype.id == 2)&& user.enabled==true));
    
           //     that.selectedUsersApp = that.userTaskService.convertDelegationUsers_To_Users(that.entity.delegUserData.filter(delegationUser => delegationUser.user.usertype.some(type =>type.projectstype.id == 2)));
    

                that.availableUsers.sort((a, b) => a.name.localeCompare(b.name));

              },
    
              function (error) {
              },
            )
            .catch(function (reason) {
              resolve();
            });
    
        });
        return promise;
    }

    async initMapAfterViewInit(event) {

        if (this.isNew) {
            this.entity.circular = true;
            this.entity.center = { latitude: 0, longitude: 0 } as Rest.Vertex;
            this.entity.radius = 0;
        }
        // Change:
        this.zones =  this.entity.zoneGroup.zones ? [...this.entity.zoneGroup.zones] : [];

        //this.zones = this.zonesList;
        //remove zone from list
        if (!this.isNew) {
            this.zones.splice(
                this.zones.findIndex((z: Rest.Zone) => z.id === this.entity.id),
                1
            );
        }
        if ((this.entity.zoneGroup && this.entity.zoneGroup.routeScheduler)) this.entity.circular = false;
        this.zones.push(this.entity);
        this.zones = this.zones.filter((z) => z.enabled);
        this.configureMap();
        if (!this.isNew) {
            window.setTimeout(() => {
                this.map.centerMapAtZone([this.entity.id]);
            }, 500);
        }

    }

    notifyUpdatePOI($event: UpdateZoneMarkerEvent) {
        // TODO: Implement!
    }

    groupChanged($event: any) {
        //TODO: Implement!!!
    }

      //generic multiselect sort (used in all multiselects)
  onMultiSelectFocus(selectedCollection: any[], fullCollection: any[]): void {
    // sortSelectedItems
    	if(!selectedCollection || !fullCollection  ){
			return; 
		}
    selectedCollection?.forEach(selectedItem => {
      // Find the index of the item in the list
      const indexToRemove = fullCollection?.findIndex(item => item.id === selectedItem.id);

      if (indexToRemove !== -1) {
        // Remove the item from the list
        fullCollection?.splice(indexToRemove, 1);
        // Add the selected item to the top of the list
        fullCollection?.unshift(selectedItem);
      }
    });
  }

  saveZonesForm() {
     //The zone group is required (*): without it the server rejects the zone with a generic error
     if (this.entity?.zoneGroup == null) {
       this.notificationsService.add(
         Severity.warn,
         this.translate.instant('zones.zone-form.zone-group'),
         this.translate.instant('error.required-field.generic')
       );
       return;
     }
     //"enabled" is required by the server: an untouched checkbox leaves it empty. New zones start enabled
     //(the server also does so on create); an existing one keeps "not enabled"
     if (this.entity.enabled == null) {
       this.entity.enabled = this.isNew ? true : false;
     }
     if (this.plannerzone)
     {
       this.entity.routes = this.selectedRoutes;
    //    let userpl: Rest_task.UserPlanner[] = [];

       

    //    this.selectedUsers.forEach(user => {
    //      userpl.push({user: user,  vehicle:[],zones: this.zones,attributes: [],fixedCost: 0,kmCost: 0,hourCost: 0,extraHourCost: 0,breakEveryTime: null,breakdriver: null,extraTimeAllowed: null,routeDistanceLimit: 0,scheduleStart: null,scheduleEnd: null,startLocalization: null,endLocalization: null,radialCost:false,radialCosts: []} as Rest_task.UserPlanner);
    //   });
    //    this.entity.userPlanners = userpl;
        const currentUserIds = this.entity.userPlanners?.map(up => up.user.id) || [];
        const newUserIds = this.selectedUsers.map(u => u.id);

        // Detectar cambios
        const usersToAdd = this.selectedUsers.filter(u => !currentUserIds.includes(u.id));
        const usersToRemove = this.entity.userPlanners?.filter(up => !newUserIds.includes(up.user.id)) || [];

        // Eliminar los UserPlanners que sobran
         this.entity.userPlanners = this.entity.userPlanners?.filter(up => !usersToRemove.includes(up)) || [];

        usersToAdd.forEach(u => {
            const newUserPlanner: Rest_task.UserPlanner= {
            id: 0, // nuevo, el backend asignará
            user: u,
            vehicle: undefined,
            attributes: [],
            fixedCost: 0,
            kmCost: 0,
            hourCost: 0,
            extraHourCost: 0,
            breakEveryTime: '',
            breakdriver: '',
            extraTimeAllowed: '',
            routeDistanceLimit: 0,
            scheduleStart: '',
            scheduleEnd: '',
            startLocalization: undefined,
            endLocalization: undefined,
            radialCost: false,
            radialCosts: [],
            zones: []
            };
            this.entity.userPlanners.push(newUserPlanner);
        });

       this.entity.eventOnEnter= false;
       this.entity.eventOnLeave =false;
     }
     else{
        this.entity.routes = null;
         this.entity.userPlanners  = null;
     }

       //An error before reaching the server used to leave the form silently "hung": show it
       try {
         this.save();
       } catch (e) {
         console.error('Could not save the zone', e);
         this.notificationsService.add(Severity.error, this.translate.instant('general.error'), String(e?.message || e));
       }
   }






  

}
